/**
 * 獲得状況の絞り込みスイッチ
 *
 * ラリー地図とラリー詳細で同じものを使う。地図の上に固定して置く前提なので、
 * 幅は呼び出し側の className で決める。
 */

import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'

import { isStampFilter, STAMP_FILTER_LABELS, type StampFilter } from './stamp-filter'

type Props = {
  value: StampFilter
  onChange: (value: StampFilter) => void
  className?: string
}

export const StampFilterTabs = ({ value, onChange, className }: Props) => (
  <Tabs value={value} onValueChange={(next) => isStampFilter(next) && onChange(next)} className={className}>
    <TabsList className="w-full">
      {(Object.keys(STAMP_FILTER_LABELS) as StampFilter[]).map((key) => (
        <TabsTrigger key={key} value={key}>
          {STAMP_FILTER_LABELS[key]}
        </TabsTrigger>
      ))}
    </TabsList>
  </Tabs>
)
